import React, { useEffect, useState, useRef } from 'react';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  BASENAME, CHARGE_KIND, CHARGE_KIND_DISPLAY, LAYOUT_TYPES, ENABLE_GOTO_AGREEMENT_FEATURE, PLAN_OPTION_CHARGE_KIND
} from '../../../constants';
import Loading from '../../atoms/Loading';
import LineTitleGray from '../../atoms/titles/LineTitleGray';
import LineTitle from '../../atoms/titles/LineTitle';
import RadioRoom from '../../atoms/form/RadioRoom';
import SelectBox from '../../atoms/form/SelectBox';
import LinkButton from '../../atoms/button/LinkButton';
import InfantCaption from '../../atoms/InfantCaption';
import TooltipIcon from '../../molecules/TooltipIcon';
import { setCurrentStep, setErrorMessages, setLayoutType, setOnCloseErrorModal } from '../../../modules/app';
import CustomerForm from '../../molecules/CustomerForm';
import { createEmptyArray } from '../../../utils';
import { usePrice } from '../../../utils/price';
import { scrollToTop } from '../../../utils/scroll';
import { makeSessionAgreeGuest, makeSessionMemberAndAccompany, makeSessionPlanOptionsOnEntry} from '../../../utils/input';
import { updateSession, useOtherSiteId } from '../../../modules/session';
import { addUnselectedOption } from '../../../utils/search';
import { applyErrorStyle, getValidationErrorMessages, removeErrorStyle } from '../../../utils/error';
import { FDataFromSession } from '../../Head';
import environments from '../../../environments';
import { getIsAna2 } from '../../../utils/Ana2';
import { getRomanAlphabetString } from '../../../utils/romanAlphabet';
import { getPlanDetailState, getSearchSessionKey } from '../../../utils/localStorage';
import { mergeSessionPlansWithPlanDetail } from '../../../utils/plans';

const Entry = ({ session }) => {
  const currentStep = 3;
  const dispatch = useDispatch();
  const [fetching, setFetching] = useState(false);
  const agreementFormRef = useRef();

  const {
    otherSiteIdData, otherSiteMemberId, setOtherSiteMemberId,
    showOtherSiteId, editOtherSiteId, fetching: fetchingOtherSiteId,
    requiredOtherSiteId, inputAttributeDisplay,
  } = useOtherSiteId();

  useEffect(() => {
    dispatch(
      setLayoutType(LAYOUT_TYPES.step)
    );
    dispatch(setCurrentStep(currentStep));

    return () => {
      dispatch(
        setLayoutType(LAYOUT_TYPES.default)
      );
    };
  }, []);

  const { state, setters } = useCustomerInfo(session);

  const {
    customers,
    message,
  } = state;

  const {
    setMessage,
  } = setters;

  const representativeCustomer = customers.length ? customers.find((a) => a.state.representative) : undefined;

  const { member, plans, flightSchedule, lands:planOptions, people } = session;
  const email = member && member.email;
  const userId = member && member.userID;
  const { numberOfRooms, hotelID, prefectureID, stayNights, femaleOnlyPlan: femaleOnly } = plans[0];

  const departureDate = moment(flightSchedule.departure.departureTime).format('YYYY-MM-DD');
  const arrivalDate = moment(flightSchedule.arrival.arrivalTime).format('YYYY-MM-DD');

  const SelectedOutboundFlight = flightSchedule.departure;
  const SelectedOutboundDate = SelectedOutboundFlight.departureTime.substr(0, 10);

  const [sortedPlanOptionKind, setSortedPlanOptionKind] = useState([]);
  useEffect(() => {
    // 着地 人員種別の選択肢 初期値
    const defaultSortedPlanOptionKind = planOptions.map((goods) => {
      return goods.chargeKinds.map((kind) => {
        if (kind.sort === 0) {
          return {
            ...kind,
            sex: representativeCustomer.state.gender === "MALE" ? 1 : 2,
          };
        }
        return kind;
      })
    });
    setSortedPlanOptionKind(defaultSortedPlanOptionKind);
  }, [planOptions]);

  const handleConfirm = async () => {
    // if (!validateState(state)) {
    //   dispatch(addErrorMessage('未入力の項目があります。'));
    //   dispatch(setOnCloseErrorModal(scrollToTop));
    //   return;
    // }

    setFetching(true);

    removeErrorStyle('pageEntry');

    const otherSiteMemberIdValue = editOtherSiteId ? otherSiteMemberId : undefined;

    //金額をセット（session.plans.children2Price が null の場合は planDetail.plans で補完）
    const plansForPrice = mergeSessionPlansWithPlanDetail(plans, getPlanDetailState(getSearchSessionKey()).plans);
    const { peoplePrice } = usePrice(people, flightSchedule.departure, flightSchedule.arrival, plansForPrice, SelectedOutboundDate, planOptions, true, sortedPlanOptionKind);
    state.customers.map((customer, index) => {
      customer.state.totalPrice = peoplePrice[index].price;
    });

    const sessionAccompany = makeSessionMemberAndAccompany(state, email, arrivalDate, otherSiteMemberIdValue);
    const sessionLands = makeSessionPlanOptionsOnEntry(planOptions, sortedPlanOptionKind);

    // sessionLandsとsessionAccompanyをマージして同時に更新
    const sessionUpdateData = {
      ...sessionLands,
      ...sessionAccompany
    };

    const onFailed = (errors) => {
      applyErrorStyle(errors);

      const messages = getValidationErrorMessages(errors);
      dispatch(setErrorMessages(messages));
      dispatch(setOnCloseErrorModal(scrollToTop));

      setFetching(false);
    };

    const onSuccess = () => {
      const isNotGuest = !!(session.member && session.member.userID);
      if (ENABLE_GOTO_AGREEMENT_FEATURE && isNotGuest) {
        agreementFormRef.current.submit();
      } else {
        dispatch(updateSession(
          makeSessionAgreeGuest(),
          () => window.open(`${BASENAME}/final_confirm`, '_self'),
          onFailed,
        ));
      }
      setFetching(false);
    };

    dispatch(updateSession(sessionUpdateData, onSuccess, onFailed));
  };

  const agreeCallbackUrl = `${environments.API_BASE_URI}/agreeResult`;

  const isAna2 = getIsAna2(SelectedOutboundFlight.airline, SelectedOutboundDate);

  const infantNum = session.people.infant || 0;
  const childrenCNum = session.people.childrenC || 0;
  const children2Num = session.people.children2 || 0;
  const peopleNumWithoutInfant = customers.length - infantNum - childrenCNum - children2Num;
  const indicatorOptions = customers.filter((c) => c.state.type === CHARGE_KIND.adult).map((c, i) => {
    const indicatorValue = String(i + 1);
    const name = i === 0 ? '代表者' : `同行者${i}`;
    return {
      id: indicatorValue,
      name,
      value: indicatorValue
    };
  });
  const haveAnyInfant = (infantNum + childrenCNum + children2Num) > 0;

  const planOptionsUseUnit = planOptions.map(option => option.useUnit);


  // 着地 人員種別の選択肢
  const [planOptionsKind, setPlanOptionsKind] = useState([]);
  const [planOptionsKindAdult, setPlanOptionsKindAdult] = useState([]);
  
  useEffect(() => {
    const newPlanOptionsKind = sortedPlanOptionKind.map((chargeKinds, itineraryIndex) => {
      const kindOptions = chargeKinds.map((kind, index) => {  
        return {
          id: `${kind.chargeKind}_${index}`, // 一意のキーを生成
          originalId: kind.chargeKind, // 元のIDを保持
          name: planOptions[itineraryIndex].useUnit === 'group' ? `${planOptions[itineraryIndex].categoryDetail}` : `${planOptions[itineraryIndex].categoryDetail} (${PLAN_OPTION_CHARGE_KIND.find((k) => k.id === kind.chargeKind).name})`,
          isAdult: PLAN_OPTION_CHARGE_KIND.find((k) => k.id === kind.chargeKind).isAdult,
          sort: kind.sort,
          useUnit: planOptions[itineraryIndex].useUnit,
        };
      });
      return kindOptions;
    });
  
    // 着地 人員種別の選択肢 大人分だけを抽出（重複を除去（originalIdで比較））
    const newPlanOptionsKindAdult = newPlanOptionsKind.map((option) => 
      option.filter((kind) => kind.isAdult)
    ).map((option) => {
      return option.reduce((unique, kind) => {
        if (!unique.find(item => item.originalId === kind.originalId)) {
          unique.push(kind);
        }
        return unique;
      }, []);
    });

    setPlanOptionsKind(newPlanOptionsKind);
    setPlanOptionsKindAdult(newPlanOptionsKindAdult);
  }, [sortedPlanOptionKind, planOptions]);

  // 代表者の種別を選択した時の処理
  const onSelectRepresentativePlanOptionKind = (e, index) => { 
    let n = 0;   
    const foundOption = sortedPlanOptionKind[index].find((kind) => kind.chargeKind === e.target.value);
    
    // 選択した人員種別
    const selectedOption = foundOption ? { ...foundOption, sort: n } : null;
    
    // 選択していない人員種別リストを年齢順にソート
    const foundIndex = sortedPlanOptionKind[index].findIndex((kind) => kind.chargeKind === e.target.value);
    const otherOptions = sortedPlanOptionKind[index].filter((kind, idx) => {
      return idx !== foundIndex;
    }).sort((a, b) => {
      const indexA = PLAN_OPTION_CHARGE_KIND.findIndex((item) => item.id === a.chargeKind);
      const indexB = PLAN_OPTION_CHARGE_KIND.findIndex((item) => item.id === b.chargeKind);
      return indexA - indexB;
    }).map((kind) => {
      n++;
      return { ...kind, sort: n };
    });
    
    // 新しいsortedPlanOptionKindには、選択した人員種別を先頭として、後ろに選択していない人員種別を並べる
    const newSortedPlanOptionKind = [...sortedPlanOptionKind];
    newSortedPlanOptionKind[index] = [selectedOption, ...otherOptions];
    setSortedPlanOptionKind(newSortedPlanOptionKind);
  }

  // Wester会員かどうかを判定
  const isWesterMember = session.wester && session.wester.sub ? true : false;

  return (
    <div id="pageEntry" className="pageEntry">
      <FDataFromSession session={session} step={currentStep} />
      <Loading show={fetching || fetchingOtherSiteId} progressRate={100} hideProgressBar />
      <div className="EntryBlock">
        <LineTitleGray size="lg">お客様情報入力</LineTitleGray>
        <div className="EntryBody">
          <div className="EntryBodyItem">
            <div className="EntryBodyItemPlanOptionKind">
              <LineTitle text="代表者情報" className="flexTitle">
                <span className="required">※必須</span>
              </LineTitle>
              {planOptionsKindAdult.length > 0 && (
                <div className="inputPlanOptionKind">
                  <div className="selectItemsWrapper">
                    {planOptionsKindAdult.map((option, index) => (
                      <div className="selectPlanOptionKindWrapper" key={index}>
                        {
                          option[0].useUnit === 'group' ? (
                            <div className="inputDisabledPlanOptionKindWrapper">
                              <input value={option[0].name} disabled={true} />
                            </div>
                          ) : (
                        <SelectBox
                          name={`planOptionKindMember`}
                          options={option.map((opt, optIndex) => ({ ...opt, id: `${opt.originalId}` }))}
                          onChange={(e) => {onSelectRepresentativePlanOptionKind(e, index)}} 
                          onClick={(e) => {onSelectRepresentativePlanOptionKind(e, index)}}
                          disabled={false} 
                          size="llg"
                        />)}
                      </div>
                    ))}
                  </div>
                  <p className="inputPlanOptionKindNotice">※タビサキMenuの参加人員に相違がある場合は、プルダウンから該当する参加人員をご選択ください。</p>
                </div>
              )}
            </div>
            {representativeCustomer && (
              <CustomerForm id="representative" representative customer={representativeCustomer} index={0} femaleOnly={femaleOnly} isAna2={isAna2} 
              planOptionChargeKinds={sortedPlanOptionKind}
              setPlanOptionChargeKinds={setSortedPlanOptionKind}/>
            )}
            <div className="EntryFormBlock">
              <label className="EntryLabel">メール送付先</label>
              <div className="inputAreaWrapper">
                <div className="inputArea">{email}</div>
              </div>
            </div>
          </div>

          {customers.length > 1 && (
            <div className="EntryBodyItem">
              <LineTitle text="同行者情報" className="flexTitle"><span className="required">※必須</span></LineTitle>
              {customers.map((c, index) => {
                if (c.state.representative) {
                  return null;
                }

                const isInfant = c.state.type === CHARGE_KIND.infant;
                const isChildren2 = c.state.type === CHARGE_KIND.children2;
                const idAdult = c.state.type === CHARGE_KIND.adult;

                // 同行者の人員種別選択肢を取得
                const thisCustomerOption = planOptionsKind.map((option) => {
                  return option.filter(option => option.sort === index);
                });

                return (
                  <React.Fragment key={index}> 
                    <div className="EntryBodyItemPlanOptionKind">
                      <div className="wrapperLabel">
                        {`同行者${index} ${CHARGE_KIND_DISPLAY[c.state.type]}`}
                        {(isInfant || (isChildren2 && !isAna2)) && (
                          <TooltipIcon>
                            <InfantCaption />
                          </TooltipIcon>
                        )}
                      </div>
                      <div className="inputPlanOptionKind accompany">
                        <div className="selectItemsWrapper">
                          {thisCustomerOption && thisCustomerOption.length > 0 && thisCustomerOption.map((option, index) => {
                            if(planOptionsUseUnit[index] === 'group') return '';
                            if(option && option.length <= 0) return '';
                            return (
                              <div className="inputDisabledPlanOptionKindWrapper" key={index}>
                                <input type="text" value={(option[0].name)} disabled={true} />
                              </div>
                            )
                          })}
                        </div>
                      </div>
                    </div>
                    <CustomerForm
                      index={index - 1}
                      id={`customer-${index}`}
                      customer={c}
                      femaleOnly={femaleOnly}
                      isAna2={isAna2}
                      indicatorOptions={indicatorOptions}
                      planOptionChargeKinds={sortedPlanOptionKind}
                      setPlanOptionChargeKinds={setSortedPlanOptionKind}
                    />
                  </React.Fragment>
                );
              })}
            </div>
          )}

          <div className="EntryBodyItem EntryBodyItemRoom">
            <LineTitle text="部屋割り" className="flexTitle"><span className="required">※必須</span></LineTitle>
            {customers && customers.length && customers.map((c, index) => {
              if (index + 1 > peopleNumWithoutInfant) {
                // https://gitlab.fqsv.net/dp-plus/front/-/issues/359
                // 幼児は部屋割りは表示しない
                return null;
              }

              const {
                representative,
                lastName,
                firstName,
                lastPhoneticName,
                firstPhoneticName,
                room,
              } = c.state;
              const title = representative ? '代表者' : `同行者${index}`;
              const totalRoomNumber = representative ? 1 : numberOfRooms;
              const phoneticName = representative ? `${lastPhoneticName || ''} ${firstPhoneticName || ''}` : `${lastName || ''} ${firstName || ''}`;

              const name = !(lastName || firstName) ?
                '(未入力)' : `${phoneticName}`;

              return (
                <div className="EntryFormBlockRoom" key={index}>
                  <div className="EntryBodyItemRoomText">
                    <div className="EntryBodyItemRoomTitle">{title}</div>
                    <div className="EntryBodyItemRoomName">{name}</div>
                  </div>
                  <div className="EntryBodyItemRoomRadio">
                    <RadioRoom
                      id={`room-${index}`}
                      totalRoomNumber={totalRoomNumber}
                      value={room}
                      onChange={(v) => c.setters.setRoom(v)}
                      withOutline
                    />
                  </div>
                </div>
              );
            })}
            {haveAnyInfant && (
              <div className="EntryFormBlockRoom noteTextRed" >※こども(0～5歳)の寝具なし（添い寝）のお子様は部屋割りには含まれません。</div>
            )}
          </div>

          <div className="EntryBodyItem notesWrapper">
            <div className="noteItems">
              <div className="noteItem">
                <div className="noteItemBody">
                  <div className="caution">
                    <div className="cautionTitle">ご注意・ご案内</div>
                    <div className="cautionText">航空券についてお申込み時にご入力いただいたお名前・性別・ご年齢にて航空券の手配をいたします。ご搭乗される方の変更や、入力情報に誤りがある場合、ご搭乗いただけません。お客様負担で正規運賃にて新たに航空券をお買い求めいただき、ご搭乗いただくことがございますので、ご注意ください。</div>
                  </div>
                  <div className="caution">
                    <div className="noteTextRed cautionTitle">お子様（こども）について</div>
                    <div className="noteTextRed cautionText">ご年齢に関係なくご参加の皆様のご予約が必要となります。必ず「6～11歳」「3～8歳」「3～5歳」「2歳」「0～1歳」のいずれかでご予約をお願いいたします。下記「要望・連絡事項」へご入力いただいてもお承りできません。6歳以上のお子様は航空座席のみ（添い寝）のご予約はお取扱はできません</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      {showOtherSiteId && !isWesterMember && (
        <div className="EntryBlock">
          <LineTitleGray size="lg">{otherSiteIdData.otherSiteMemberIdHeader}</LineTitleGray>
          <div style={{ marginTop: 16 }}>
            <img className="isPC" src={otherSiteIdData.logoFileName} />
            <img className="isSP" src={otherSiteIdData.logoFileNameSp} />
          </div>
          <div className="EntryBody" style={{ paddingTop: 16 }}>
            <div className="lifeSupportTitle">
              <div>{otherSiteIdData.otherSiteMemberIdDispName}</div>
              {requiredOtherSiteId && <div className="required">※必須</div>}
            </div>
            <div className="lifeSupportInput">
              {editOtherSiteId ? (
                <input
                  id="input.otherSiteId.otherSiteMemberId"
                  type="text"
                  placeholder="0123456789"
                  value={otherSiteMemberId || ''}
                  onChange={(e) => setOtherSiteMemberId(e.target.value)}
                />
              ) : (
                <span>{otherSiteMemberId}</span>
              )}
            </div>
            <div className="lifeSupportSups">
              <div className="lifeSupportSup">{inputAttributeDisplay}</div>
              <div className="lifeSupportSup" dangerouslySetInnerHTML={{ __html: otherSiteIdData.fixedWording }} />
            </div>
          </div>
        </div>
      )}
      <div className="EntryActions">
        <div className="linkActions">
          <div className="linkMypage">
            <LinkButton buttonType="cta" onClick={handleConfirm}>最終確認へ進む</LinkButton>
          </div>
        </div>
      </div>
      <form ref={agreementFormRef} action={environments.DP_AGREEMENT_URI} method="POST" style={{ display: 'none'}}>
        <input hidden name="session" value={session.id} readOnly />
        <input hidden name="r_url" value={agreeCallbackUrl} readOnly />
        <input hidden name="back_url" value={agreeCallbackUrl} readOnly />
        {prefectureID && <input hidden name="pref_code" value={prefectureID} readOnly />}
        {hotelID && <input hidden name="hotel_code" value={hotelID} readOnly />}
        {userId && <input hidden name="userid" value={userId} readOnly />}
        <input hidden name="dep_date" value={departureDate} readOnly />
        {stayNights && <input hidden name="stay_num" value={stayNights} readOnly />}
        <input hidden name="arr_date" value={arrivalDate} readOnly />
      </form>
    </div>
  );
};

Entry.propTypes = {
  session: PropTypes.object,
};

export default Entry;

const useCustomer = (initialType, isRepresentative = false, member, femaleOnly, isAna2) => {
  const [representative, setRepresentative] = useState(isRepresentative);

  const initialFirstName = member ? member.name.first : '';
  const initialLastName = member ? member.name.last : '';
  const [firstName, setFirstName] = useState(initialFirstName);
  const [lastName, setLastName] = useState(initialLastName);

  const initialFirstPhoneticName = isRepresentative && member ? member.phoneticName.first : '';
  const initialLastPhoneticName = isRepresentative && member ? member.phoneticName.last : '';
  const [firstPhoneticName, setFirstPhoneticName] = useState(initialFirstPhoneticName);
  const [lastPhoneticName, setLastPhoneticName] = useState(initialLastPhoneticName);

  const initialFirstAlphabetName = isRepresentative && member ? member.alphabetName.first : '';
  const initialLastAlphabetName = isRepresentative && member ? member.alphabetName.last : '';
  const [firstAlphabetName, setFirstAlphabetName] = useState(initialFirstAlphabetName);
  const [lastAlphabetName, setLastAlphabetName] = useState(initialLastAlphabetName);

  const initialBirthYear = member && member.birthday ? moment(member.birthday, 'YYYY-MMDD').format('YYYY') : '';
  const initialBirthMonth = member && member.birthday ? moment(member.birthday, 'YYYY-MMDD').format('M') : '';
  const initialBirthDate = member && member.birthday ? moment(member.birthday, 'YYYY-MMDD').format('D') : '';
  const [birthYear, setBirthYear] = useState(initialBirthYear);
  const [birthMonth, setBirthMonth] = useState(initialBirthMonth);
  const [birthDate, setBirthDate] = useState(initialBirthDate);
  const initialGender = femaleOnly ? 'FAMALE' : member ? member.sex : null;
  const [gender, setGender] = useState(initialGender);

  const initialPhoneType = isRepresentative && member ? member.contact.type : 'MOBILE';
  const initialPhoneNumber1 = isRepresentative && member ? member.contact.tel.first : '';
  const initialPhoneNumber2 = isRepresentative && member ? member.contact.tel.second : '';
  const initialPhoneNumber3 = isRepresentative && member ? member.contact.tel.third : '';
  const [phoneType, setPhoneType] = useState(initialPhoneType);
  const [phoneNumber1, setPhoneNumber1] = useState(initialPhoneNumber1);
  const [phoneNumber2, setPhoneNumber2] = useState(initialPhoneNumber2);
  const [phoneNumber3, setPhoneNumber3] = useState(initialPhoneNumber3);

  const initialPostalCode1 = isRepresentative && member && member.postalCode ?  member.postalCode.substring(0, 3) : '';
  const initialPostalCode2 = isRepresentative && member && member.postalCode ?  member.postalCode.substring(3, 7) : '';
  const initialPrefectureId = isRepresentative && member && member.prefectureID ? member.prefectureID : '13';
  const initialAddress1 = isRepresentative && member ? member.address1 || '' : '';
  const initialAddress2 = isRepresentative && member ? member.address2 || '' : '';
  const [postalCode1, setPostalCode1] = useState(initialPostalCode1);
  const [postalCode2, setPostalCode2] = useState(initialPostalCode2);
  const [prefectureId, setPrefectureId] = useState(initialPrefectureId);
  const [address1, setAddress1] = useState(initialAddress1);
  const [address2, setAddress2] = useState(initialAddress2);

  const [type, setType] = useState(initialType);
  const isInfant = initialType === CHARGE_KIND.infant;
  const isChildren2 = initialType === CHARGE_KIND.children2;
  const isChildrenC = initialType === CHARGE_KIND.childrenC;
  const initialIndicator = (isInfant || (isChildren2 && !isAna2)) ? '1' : undefined;
  const [infantIndicator, setInfantIndicator] = useState(initialIndicator);

  const initialRoom = isRepresentative ? 1 : member ? member.roomAllocation : 1;
  const [room, setRoom] = useState((isInfant || isChildren2 || isChildrenC)? undefined : initialRoom);

  const initialTotalPrice = 0;
  const [totalPrice, setTotalPrice] = useState(initialTotalPrice);

  const state = {
    representative,
    firstName,
    lastName,
    firstPhoneticName,
    lastPhoneticName,
    firstAlphabetName,
    lastAlphabetName,
    birthYear,
    birthMonth,
    birthDate,
    gender,
    phoneType,
    phoneNumber1,
    phoneNumber2,
    phoneNumber3,
    postalCode1,
    postalCode2,
    prefectureId,
    address1,
    address2,
    type,
    infantIndicator,
    room,
    totalPrice,
  };

  const setters = {
    setRepresentative,
    setFirstName,
    setLastName,
    setFirstPhoneticName,
    setLastPhoneticName,
    setFirstAlphabetName,
    setLastAlphabetName,
    setBirthYear,
    setBirthMonth,
    setBirthDate,
    setGender,
    setPhoneType,
    setPhoneNumber1,
    setPhoneNumber2,
    setPhoneNumber3,
    setPostalCode1,
    setPostalCode2,
    setPrefectureId,
    setAddress1,
    setAddress2,
    setType,
    setInfantIndicator,
    setRoom,
    setTotalPrice,
  };
  useEffect(() => {
    const converted_lastName = representative ? getRomanAlphabetString(lastPhoneticName) : getRomanAlphabetString(lastName);
    const converted_firstName = representative ? getRomanAlphabetString(firstPhoneticName) : getRomanAlphabetString(firstName);
    setLastAlphabetName(converted_lastName);
    setFirstAlphabetName(converted_firstName);
  }, [lastPhoneticName, firstPhoneticName, lastName, firstName, representative]);

  return { state, setters };
};

const initCustomers = (session) => {
  const { member, accompanies, people, plans, flightSchedule } = session;
  let { adult, childrenA, childrenB, childrenC, children2, infant } = people;
  if (!childrenA) {
    childrenA = 0;
  }
  if (!childrenB) {
    childrenB = 0;
  }
  if(!childrenC){
    childrenC = 0;
  }
  if(!children2){
    children2 = 0;
  }
  if (!infant) {
    infant = 0;
  }
  const totalCutomersNumber = adult + childrenA + childrenB + infant + childrenC + children2;

  const femaleOnly = plans && plans[0].femaleOnlyPlan;

  return createEmptyArray(totalCutomersNumber).map(( _, i) => {
    const representative = i === 0;
    let type = CHARGE_KIND.adult;
    if (i >= adult) {
      if (i >= adult + childrenA + childrenB + childrenC + children2) {
        type = CHARGE_KIND.infant;
      } else if (i >= adult + childrenA + childrenB + childrenC) {  
        type = CHARGE_KIND.children2;
      } else if (i >= adult + childrenA + childrenB) {
        type = CHARGE_KIND.childrenC;
      } else if(i >= adult + childrenA){
        type = CHARGE_KIND.childrenB;
      } else {
        type = CHARGE_KIND.childrenA;
      }
    }
    const initialState = representative ? member : (accompanies && accompanies.length) ? accompanies[i - 1] : undefined;

    //ANAPhase2判定
    const SelectedOutboundFlight = flightSchedule.departure;
    const SelectedOutboundDate = SelectedOutboundFlight.departureTime.substr(0, 10);
    const isAna2 = getIsAna2(SelectedOutboundFlight.airline, SelectedOutboundDate);
    
    return useCustomer(type, representative, initialState, femaleOnly, isAna2);
  });
};

const useCustomerInfo = (session) => {

  let customers = initCustomers(session);

  const { member } = session;

  const initialMessage = member ? member.note || '' : '';
  const [message, setMessage] = useState(initialMessage);

  const state = {
    customers,
    message,
  };

  const setters = {
    setAdultCustomers: customers.map((c) => c.setters),
    setMessage,
  };

  return { state, setters };
};

// const validateState = ({ customers, lifeSupportNumber }) => {
//   const validations = customers.map(validateCustomer);
//   //TODO lifeSupportNumberのハンドリングをいれる
//   return customers.length === validations.filter(Boolean).length;
//   // return lifeSupportNumber && customers.length === validations.filter(Boolean).length;
// };

// const validateCustomer = ({ state: customerState }) => {
//   const {
//     representative,
//     firstName,
//     lastName,
//     firstPhoneticName,
//     lastPhoneticName,
//     birthYear,
//     birthMonth,
//     birthDate,
//     gender,
//     phoneType,
//     phoneNumber1,
//     phoneNumber2,
//     phoneNumber3,
//     room,
//   } = customerState;

//   const essential = !!(firstName && lastName && birthYear && birthMonth && birthDate && gender && room);
//   const representativeValidation = !!(firstPhoneticName && lastPhoneticName &&
//                                       phoneType && phoneNumber1 && phoneNumber2 && phoneNumber3);

//   return representative ? essential && representativeValidation : essential;
// };
